export const SET_DISPLAY_PROFILE_MODAL = 'SET_DISPLAY_PROFILE_MODAL';
export const SET_IS_LOADING_PROFILES = 'SET_IS_LOADING_PROFILES';
export const SET_PROFILE_LAYOUT_TYPE = 'SET_PROFILE_LAYOUT_TYPE';
export const GET_AVATARS_COLLECTIONS = 'GET_AVATARS_COLLECTION';
export const GET_PROFILES_INFO = 'GET_PROFILES_INFO';
export const SET_PROFILE_FORM_FIELD = 'SET_PROFILE_FORM_FIELD';
export const CREATE_PROFILE_SUCCESS = 'CREATE_PROFILE_SUCCESS';
export const UPDATED_PROFILE_INFO = 'UPDATED_PROFILE_INFO';
export const CLEAR_PROFILE_FORM = 'CLEAR_PROFILE_FORM';
export const SHOW_PROFILE_LOADER = 'SHOW_PROFILE_LOADER';
export const HIDE_PROFILE_LOADER = 'HIDE_PROFILE_LOADER';
